export var ClientConfiguation = {
    ServerExport: "Server_Export",
    ExportBatchSize: "Export-BatchSize",
    ExportRequestDelay: "Export-RequestDelay",
    TopMenuDisableHelpLink: "yes",
    NHSS_JobSearchBySchool: "NHSS_JobSearchBySchool",
    ShowObV2: "ShowObV2",
    Feature_Enhanced_Job_Approval: "feature_enhanced_job_approval",
    NewStarterFilter: "NewStarterFilter",
    Helpdesk_Link: "Helpdesk_Link",
    Helpdesk_KnowledgeHub: "Helpdesk_KnowledgeHub",
    NhssAdditionalInfo: "NhssAdditionalInfo",
    Deny_Application_Form_Removal: "Deny_Application_Form_Removal",
    BrandBuilderLoginUrl: "BrandBuilderLoginUrl",
    ShowNhsPropertyBankDetails: "ShowNhsPropertyBankDetails",
    JobAdvertUrl: "JobAdvertUrl",
    IsNewCandidateSide: "IsNewCandidateSide",
    FeatureBankDetails: "Feature_BankDetails",
    Feature_InterviewComplete: "Feature_InterviewComplete",
    AdminFormSectionHeadingClasses: "AdminForm-SectionHeadingClasses",
    ShowCodeField: "ShowCodeField",
    EqualOopsDisabilityAddDontknow: "EqualOops_Disability_Add_DontKnow",
    EqualOopsRemovePreferNotToSay: "EqualOops_Remove_PreferNotTosay",
    FeatureDirectApply: "feature-direct-apply",
    FeatureIndeedDirectApply: "feature-indeed-direct-apply",
    FeatureStripe: "Feature_Stripe",
    Logos_Settings: "Logos_Settings",
    Feature_Vonq: "Feature_Vonq",
    Feature_private_job: "feature_private_job",
  FeatureMultiPanelShortlisting: "feature-multi-panel-shortlisting",
  FeatureIndexDbForShortlisting: "feature-index-db-for-shortlisting-forms",
    feature_CV_Library: "feature-cv-library",
    FeatureChangeStatusWithoutSendingEmail: "feature-change-status-without-sending-email",
    Feature_ExcludeNumber_In_SectionHeader: "Feature_ExcludeNumber_In_SectionHeader",
    feature_Ranking_Start: "feature-candidate-list-number-of-ranking-stars",
    feature_jobadvert_copy_from_internal: "feature-jobadvert-copy-from-internal",
    feature_do_not_allow_empty_closing_date: "feature-do-not-allow-empty-closing-date",
    Feature_Cintra: "feature_cintrta",
    Feature_Cintra_File_Download: "Feature_Cintra_File_Download",
    featureOpenApi: "feature-open-api",
    FeatureVoyageCareNewStarterExtract: "feature-voyage-care-new-starter-extract",
    FeatureReorderedQuestuionNo: "feature-reordered-question-no",
    config_allow_recruiter: "config-allow-recruiter",
    restoreCandidateData: "restore-candidate-data",
    Feature_Itrent_Integration: "feature_itrent_integration",
    Feature_Itrent_Integration_File_Download: "feature_itrent_integration_file_download",
    config_iTrent_remove_encapsulation: "config-iTrent-remove-encapsulation",
    feature_ESR: "feature-esr",
    Feature_ESR_File_Download: "feature-esr-file-download",
    Feature_ESR_Employment_Checks_File_Download: "feature-esr-employment-checks-file-download",
    ESRVPDCode: "esr-vpd-code",
    featureAcceptDeclineInterview: "feature-accept-decline-interview",
    featureNTUDocumentExtract: "feature-NTU-doc-extract",
    loadProcessDataForNTUDataExtraction: "Load-process-data-for-NTU-data-extraction",
    showBankDetailOnStarterForm: "show_bank_detail_on_starter_form",
    isValidateNationalInsuranceNumberWithPattern: "config-validate-national-insurance-number-with-pattern",
    nationalInsuranceNumbervalidationPattern: "config-national-insurance-number-validation-pattern",
    AllowBankDetailStudentLoanField: "config-bank-detail-student-loan",
    ConfigStarterFormProposedStartDateFieldId: "config-starter-form-proposed-start-date-fieldId",
    ConfigStarterFormStartedApplicationStatusId: "config-starter-form-started-application-statusId",
    FeatureCRM: "feature-crm",
    JTURL: "JTURL",
    hideDisplayOrderFromLocation: "config_hide_display_order_from_location_setup",
    disableCalendarShowAssignEventToCampaign: "config-disable-calendar-show-assign-event-to-campaign",
    disableCalendarShowLinkEventToAllJobsAtLocation: "config-disable-calendar-show-link-event-to-all-jobs-at-location",
    hide_attention_grabber: "config-add-job-hide-attention-grabber",
    hide_advert_doc_library_search: "config-add-job-hide-advert-doc-library-search",
    prevent_doc_library_upload: "config-prevent-doc-library-upload",
    FeatureJobAdvertPreviewToken: "feature-job-advert-preview-token",
    check_feature_advert_exists: "config-add-job-check-advert-exists-before-approval",
    FeatureAlphabetAnonymousSearch: "featureAlphabetAnonymousSearch",
    featureRedeployment: "feature-redeployment",
    FeatureReportBuilder: "feature-report-builder",
    config_import_candidate_send_in_complete_application_email: "config-import-candidate-send-in-complete-application-email"
}
